
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import SeoSchema from "./components/SeoSchema";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SeoSchema />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
